import { getCurrentUser } from '../actions/userActions'
import { loadOrgContext } from './loadOrgContext'
import {
	setAuthUser,
	setOrgMemberships,
	setCurrentOrg,
	setCurrentExperience,
} from '../store/userSlice'
import { clearOrgState } from '../store/orgSlice'

export const loadUserContext = async (dispatch) => {
	try {
		const user = await getCurrentUser()
		const currentOrg = user?.currentOrg
			? {
					orgId: user.currentOrg.id,
					orgSlug: user.currentOrg.slug,
					orgName: user.currentOrg.name,
					role: user.currentOrg.role,
					isActive: user.currentOrg.isActive !== false,
					deactivatedAt: user.currentOrg.deactivatedAt || null,
				}
			: null

		dispatch(
			setAuthUser({
				id: user.id,
				name: user.name,
				email: user.email,
				phone: user.phone,
				userType: user.userType,
			})
		)

		dispatch(setOrgMemberships(user.orgMemberships || []))

		dispatch(setCurrentOrg(currentOrg))

		dispatch(
			setCurrentExperience(
				currentOrg?.isActive === false ? null : user.currentExperience || null
			)
		)

		if (currentOrg?.isActive === false) {
			dispatch(clearOrgState())
			return
		}

		await loadOrgContext(currentOrg?.orgSlug, dispatch)
	} catch (err) {
		console.error('❌ Failed to load user context:', err)
		throw err
	}
}
